import {Component, EventEmitter, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";
import {DateHelper} from "../../../_helpers/date.helper";
import {isMoment} from "moment";

@Component({
    selector: 'adv-search-admin-user',
    templateUrl: './admin-user-advance-search.dialog.html',
    styleUrls: ['../../../scss/office.scss']
})
export class AdminUserAdvanceSearchDialog implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public dateHelper = DateHelper;

    constructor(
        public dialogRef: MatDialogRef<AdminUserAdvanceSearchDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder
    ) {
       this.form = this.formBuilder.group({
           createDate: [null, []],
           accountType: [[], []],
           userRole: [[], []],
        });
    }

    ngOnInit() {
        const filters = this.data.pageQuery.filters;
        console.log(filters);
        if(filters && filters.createDate) {
            this.form.controls.createDate.setValue(filters.createDate[0]);
        }
        if(filters && filters.accountType) {
            this.form.controls.accountType.setValue(filters.accountType);
        }
        if(filters && filters.roles) {
            this.form.controls.userRole.patchValue(filters.roles);
        }
    }

    removeOption(option: any) {
        const selected = this.form.controls.accountType.value.filter((o: string) => o !== option);
        this.form.controls.accountType.setValue(selected);
    }

    removeOptionRole(option: any) {
        const selected = this.form.controls.userRole.value.filter((o: string) => o !== option);
        this.form.controls.userRole.setValue(selected);
    }

    onOptionChange($event: MatSelectChange) {
        this.form.controls.accountType.setValue($event.value);
    }

    onRoleChange($event: MatSelectChange) {
        this.form.controls.userRole.setValue($event.value);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    resetForm() {
        this.form.controls.accountType.setValue([]);
        this.form.controls.userRole.setValue([]);
        this.form.controls.createDate.setValue(null);
    }

    applyFilter() {
        const payload = {
            accountType: this.form.controls.accountType.value,
            roles: this.form.controls.userRole.value,
            createDate: [
                isMoment(this.form.controls.createDate.value)? this.dateHelper.momentToDbDate(this.form.controls.createDate.value):this.form.controls.createDate.value
            ],
        }

        if(payload.roles == null || payload.roles.length == 0) {
            payload.roles = undefined;
        }

        if(payload.accountType.length == 0) {
            payload.accountType = undefined;
        }

        if(payload.createDate[0] == null) {
            payload.createDate = undefined;
        }

        this.result.emit(payload);
        this.closeDialog();
    }
}
